export default __webpack_public_path__ + "static/media/hot-inarticle-mobile.b78b0620.jpg";